import angular from 'angular';

angular
    .module('rebroadcast')

    .controller('RebroadcastModalChooseCtrl', [
        '$scope',
        '$uibModalInstance',
        'LadProviderService',
        'nbSelected',
        'nbEnvelopeSpecific',
        function($scope, $uibModalInstance, LadProviderService, nbSelected, nbEnvelopeSpecific) {
            $scope.nbSelected = nbSelected;
            $scope.ladProviders = LadProviderService.findByStatus({ status: 'ENABLE' });

            $scope.includes = {
                formMessages: require('../../../common/form-messages.html')
            };

            $scope.criteria = {
                platform: undefined,
                ladProviderIdPlatform: undefined,
                quali: undefined,
                ladProviderIdQuali: undefined,
                motif: []
            };

            if (nbSelected === nbEnvelopeSpecific) {
                $scope.onlySpecific = true;
            } else {
                $scope.onlySpecific = false;
            }

            $scope.isFormValid = function() {
                if (
                    $scope.criteria.motif != undefined &&
                    $scope.criteria.motif.length > 0 &&
                    !$scope.sameLAD() &&
                    ($scope.criteria.quali == true || $scope.criteria.platform == true)
                ) {
                    return false;
                }
                return true;
            };

            $scope.sameLAD = function() {
                if (
                    $scope.criteria.ladProviderIdPlatform == $scope.criteria.ladProviderIdQuali &&
                    $scope.criteria.ladProviderIdPlatform != '' &&
                    $scope.criteria.ladProviderIdPlatform != undefined
                ) {
                    return true;
                }
            };

            $scope.ok = function() {
                if ($scope.form.$valid) {
                    $uibModalInstance.close($scope.criteria);
                }
            };

            $scope.cancel = function() {
                $uibModalInstance.dismiss('cancel');
            };
        }
    ]);
